module.exports = __webpack_public_path__ + "img/icon-usb.6e0d05b1.svg";